import { IOffer, IRailway } from '../types/offer';
import { IJsonQueryRailway } from '../types/json-query';
import { getOrder } from './getOrder';

/**
 * Берем Ж/Д из гео офера geo.railways
 * выводим первый элемент из списка, отсортировав в соответствии с geo.sortedGeoIds
 * @param offer
 * @return IRailway | undefined
 */
export function getRailway( offer: IOffer): IRailway | undefined {
  const { geo } = offer;

  if (geo && geo.railways) {
    const railwaysOrderMap: Map<number, number> =
      ((geo.sortedGeoIds || []).filter(item => item.type === 'railway') as IJsonQueryRailway[])
        .reduce((map, item, index) => {
          map.set(item.id, index);

          return map;
        }, new Map<number, number>());

    /**
     * Сортируем согласно порядку полученному из geo.sortedGeoId
     * станции, по каким то причинам, не попавшие в geo.sortedGeoId, идут низшим приоритетом
     */
    const offerRailways = geo.railways
      .concat()
      .sort(
        (a, b) =>
          getOrder(railwaysOrderMap, a.id, Infinity) -
          getOrder(railwaysOrderMap, b.id, Infinity),
      );

    return offerRailways[0];
  }

  return undefined;
}
